import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { AppVersionModel } from "./app-version-form-model";

export class AppVersionGridParams extends GridPostParams {}

export class AppVersionGridModel extends AppVersionModel { }

export class AppVersionListingModel extends GridModel<AppVersionGridModel> { }